import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen w-full cosmic-sky flex items-center justify-center px-6">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="crystal rounded-3xl p-8 max-w-md w-full text-center"
            >
                <div className="flex justify-center">
                    <XCircle className="w-16 h-16 text-slate-400" />
                </div>
                <h1 className="font-display font-black text-3xl tracking-tighter text-slate-900 mt-4">
                    Checkout cancelled.
                </h1>
                <p className="text-slate-600 mt-2 text-sm">
                    Your ledger is still here whenever you decide to unlock full access.
                </p>
                <Link to="/paywall" className="arcade-btn w-full mt-6" data-variant="primary" data-testid="try-again-checkout">
                    Try again <ArrowRight className="w-4 h-4" />
                </Link>
            </motion.div>
        </div>
    );
}
